//Url Base
export const baseUrl = document.getElementById('baseFullPath').getAttribute('href');
export const baseUrlRel = document.getElementById('baseRelativePath').getAttribute('href');

//Controllers Web API po menu

const accionesController = 'API/Acciones'
const loginController = 'API/Login';
const mantenimientoController = 'API/Mantenimientos';
const menuController = 'API/Menu';
const seguridad = 'API/Seguridad';
const servicioController = 'API/Servicio';
const Reporte = 'Reporte';


//Routes

export const AccionesRutas = {





}


export const LoginRutas = {
    Cambiar_Contrasena: `${baseUrl}${loginController}/Cambiar_Contrasena`,
    Login: `${baseUrl}${loginController}/Login`,
    Login_Token: `${baseUrl}${loginController}/Login_Token`,
};

export const MenuRutas = {
    Obtener_Menu: `${baseUrl}${menuController}/Obtener_Menu`,
    Obtener_MenuOpciones: `${baseUrl}${menuController}/Obtener_MenuOpciones`,
    Seg_Usuario_Validar_Opcion: `${baseUrl}${menuController}/Seg_Usuario_Validar_Opcion`,
    Get_Description_Report: `${baseUrl}${menuController}/Get_Description_Report`,
    Obtener_MenuNombre: `${baseUrl}${menuController}/Obtener_MenuNombre`,
    SegMenuOpciones_Lista: `${baseUrl}${menuController}/SegMenuOpciones_Lista`,
    Menu_Validar_Opcion: `${baseUrl}${menuController}/Menu_Validar_Opcion`,
};

export const MantenimientosRutas = {   
    Cantidad_DecimalesPocentaje: `${baseUrl}${mantenimientoController}/Cantidad_DecimalesPocentaje`,
    Cantidad_DecimalesMoneda: `${baseUrl}${mantenimientoController}/Cantidad_DecimalesMoneda`,
    Cantidad_DecimalesCantidad: `${baseUrl}${mantenimientoController}/Cantidad_DecimalesCantidad`,

    CatalogoHist_ListarPeriodos: `${baseUrl}${mantenimientoController}/CatalogoHist_ListarPeriodos`,
    CatalogoHist_ListarTablaSaldos: `${baseUrl}${mantenimientoController}/CatalogoHist_ListarTablaSaldos`, 
    CatalogoXCentroCosto_Consulta:`${baseUrl}${mantenimientoController}/CatalogoXCentroCosto_Consulta`, 
    CatalogoXCentroCosto_Listar:`${baseUrl}${mantenimientoController}/CatalogoXCentroCosto_Listar`,
    CatalogoXCentroCosto_ListarAsociarCC:`${baseUrl}${mantenimientoController}/CatalogoXCentroCosto_ListarAsociarCC`,
    CatalogoXCentroCosto_Guardar:`${baseUrl}${mantenimientoController}/CatalogoXCentroCosto_Guardar`,
    CatalogoXCentroCosto_Modificar:`${baseUrl}${mantenimientoController}/CatalogoXCentroCosto_Modificar`,
    CatalogoXCentroCosto_ModificarEstado:`${baseUrl}${mantenimientoController}/CatalogoXCentroCosto_ModificarEstado`,
    CatalogoXCentroCosto_Eliminar:`${baseUrl}${mantenimientoController}/CatalogoXCentroCosto_Eliminar`,
    Catalogo_AsociarCuenta_CentroCostoSP:`${baseUrl}${mantenimientoController}/Catalogo_AsociarCuenta_CentroCostoSP`,    
    CentrosCost_Eliminar: `${baseUrl}${mantenimientoController}/CentrosCost_Eliminar`,
    CentrosCost_Modificar_Usuario: `${baseUrl}${mantenimientoController}/CentrosCost_Modificar_Usuario`,
    CentrosCost_Guardar: `${baseUrl}${mantenimientoController}/CentrosCost_Guardar`, 
    CentrosCost_Listar: `${baseUrl}${mantenimientoController}/CentrosCost_Listar`,
    CentrosCostos_Listar_Porcentaje:`${baseUrl}${mantenimientoController}/CentrosCostos_Listar_Porcentaje`,
    CentrosCost_Modificar: `${baseUrl}${mantenimientoController}/CentrosCost_Modificar`,
    CentrosUtilidad_Consulta :`${baseUrl}${mantenimientoController}/CentrosUtilidad_Consulta`,
    CentrosUtilidad_Listar:`${baseUrl}${mantenimientoController}/CentrosUtilidad_Listar`,
    CentrosUtilidad_Guardar:`${baseUrl}${mantenimientoController}/CentrosUtilidad_Guardar`,
    CentrosUtilidad_Modificar:`${baseUrl}${mantenimientoController}/CentrosUtilidad_Modificar`,
    CentrosUtilidad_Eliminar:`${baseUrl}${mantenimientoController}/CentrosUtilidad_Eliminar`,
    Contabilidad_CerrarMes: `${baseUrl}${mantenimientoController}/Contabilidad_CerrarMes`,
    Conciliacion_Busca_Cuentas: `${baseUrl}${mantenimientoController}/Conciliacion_Busca_Cuentas`,
    Conciliacion_Datos_Concilia: `${baseUrl}${mantenimientoController}/Conciliacion_Datos_Concilia`,
    ConsultarDatos_Reporte: `${baseUrl}${mantenimientoController}/ConsultarDatos_Reporte`,
    Contabilidad_CerrarPeriodo: `${baseUrl}${mantenimientoController}/Contabilidad_CerrarPeriodo`,
    Contabilidad_ObtenerContadorAsiento: `${baseUrl}${mantenimientoController}/Contabilidad_ObtenerContadorAsiento`,
    Contabilidad_HayAuxiliaresSinCerrar: `${baseUrl}${mantenimientoController}/Contabilidad_HayAuxiliaresSinCerrar`,
    Corporacion_Consulta: `${baseUrl}${mantenimientoController}/Corporacion_Consulta`,
    Corporacion_Listar: `${baseUrl}${mantenimientoController}/Corporacion_Listar`,
    Corporacion_Guardar: `${baseUrl}${mantenimientoController}/Corporacion_Guardar`,
    Corporacion_Modificar: `${baseUrl}${mantenimientoController}/Corporacion_Modificar`,
    Corporacion_Eliminar: `${baseUrl}${mantenimientoController}/Corporacion_Eliminar`,
    DetalleAsiento_Listar: `${baseUrl}${mantenimientoController}/DetalleAsiento_Listar`,
    DetalleCentroCostos_Eliminar: `${baseUrl}${mantenimientoController}/DetalleCentroCostos_Eliminar`,
    DetalleCentroCostos_GuardarLista: `${baseUrl}${mantenimientoController}/DetalleCentroCostos_GuardarLista`,
    DetalleCentroCostos_Listar: `${baseUrl}${mantenimientoController}/DetalleCentroCostos_Listar`,
    DetallePlantillas_Consultar: `${baseUrl}${mantenimientoController}/DetallePlantillas_Consultar`,
    DetallePlantillas_Listar: `${baseUrl}${mantenimientoController}/DetallePlantillas_Listar`,    
    DetalleCentroUtilidad_Listar:`${baseUrl}${mantenimientoController}/DetalleCentroUtilidad_Listar`,
    EmpresaImagen_Consulta:`${baseUrl}${mantenimientoController}/EmpresaImagen_Consulta`,
    EmpresaImagen_SubirImagen: `${baseUrl}${mantenimientoController}/EmpresaImagen_SubirImagen`,
    EncabezadoAsiento_Aplicar: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_Aplicar`,
    EncabezadoAsiento_CambiarMes: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_CambiarMes`,
    EncabezadoAsiento_Desbloquear: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_Desbloquear`,
    EncabezadoAsiento_ExportarAExcel: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_ExportarAExcel`,
    EncabezadoAsientos_Existe_Cuenta: `${baseUrl}${mantenimientoController}/EncabezadoAsientos_Existe_Cuenta`,
    EncabezadoAsiento_Listar: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_Listar`,
    EncabezadoAsientosReporte_Listar: `${baseUrl}${mantenimientoController}/EncabezadoAsientosReporte_Listar`,
    EncabezadoAsiento_ListarUtilizado: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_ListarUtilizado`,
    EncabezadoAsiento_ObtenerContador: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_ObtenerContador`,
    EncabezadoAsiento_ObtenerAsiento: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_ObtenerAsiento`,
    EncabezadoAsiento_Guardar: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_Guardar`,
    EncabezadoAsiento_Modificar: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_Modificar`,
    EncabezadoAsiento_ModificarDesdeExcel: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_ModificarDesdeExcel`,
    EncabezadoAsiento_ModificarEstado: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_ModificarEstado`,
    EncabezadoAsiento_ModificarUtilizado: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_ModificarUtilizado`,
    EncabezadoAsiento_Reversar: `${baseUrl}${mantenimientoController}/EncabezadoAsiento_Reversar`,
    EncaPlantillas_Consultar: `${baseUrl}${mantenimientoController}/EncaPlantillas_Consultar`,
    EncaPlantillas_Eliminar: `${baseUrl}${mantenimientoController}/EncaPlantillas_Eliminar`,
    EncaPlantillas_Guardar: `${baseUrl}${mantenimientoController}/EncaPlantillas_Guardar`,
    EncaPlantillas_Listar: `${baseUrl}${mantenimientoController}/EncaPlantillas_Listar`,
    EncaPlantillas_Modificar: `${baseUrl}${mantenimientoController}/EncaPlantillas_Modificar`,        
    EncaPlantillas_ModificarFechaAct: `${baseUrl}${mantenimientoController}/EncaPlantillas_ModificarFechaAct`,
    HayAsientosCentroCosto:`${baseUrl}${mantenimientoController}/HayAsientosCentroCosto`,
    ModulosConcilia_Listar: `${baseUrl}${mantenimientoController}/ModulosConcilia_Listar`,        
    Parametros_Consulta: `${baseUrl}${mantenimientoController}/Parametros_Consulta`,
    Parametros_Listar: `${baseUrl}${mantenimientoController}/Parametros_Listar`,
    Parametros_Guardar: `${baseUrl}${mantenimientoController}/Parametros_Guardar`,
    Parametros_Modificar: `${baseUrl}${mantenimientoController}/Parametros_Modificar`,
    Parametros_Eliminar: `${baseUrl}${mantenimientoController}/Parametros_Eliminar`,
    ParametroCadena_Listar: `${baseUrl}${mantenimientoController}/ParametroCadena_Listar`,
    Presupuesto_Listar: `${baseUrl}${mantenimientoController}/ListarDatos_Presupuesto`,
    Presupuesto_EliminarLista:`${baseUrl}${mantenimientoController}/Presupuesto_EliminarLista`,
    Presupuesto_GuardarLista:`${baseUrl}${mantenimientoController}/Presupuesto_GuardarLista`,
    TipoAsiento_Listar: `${baseUrl}${mantenimientoController}/TipoAsiento_Listar`,
    TipoAsiento_Consulta: `${baseUrl}${mantenimientoController}/TipoAsiento_Consulta`,
    TipoAsiento_Guardar: `${baseUrl}${mantenimientoController}/TipoAsiento_Guardar`,
    TpoAsiento_ImportarTipoAsiento: `${baseUrl}${mantenimientoController}/TpoAsiento_ImportarTipoAsiento`,
    TipoAsiento_Modificar: `${baseUrl}${mantenimientoController}/TipoAsiento_Modificar`,
    TipoAsiento_Eliminar: `${baseUrl}${mantenimientoController}/TipoAsiento_Eliminar`,
    TipoAsientos_ObtenerTotalTipoAsiento: `${baseUrl}${mantenimientoController}/TipoAsientos_ObtenerTotalTipoAsiento`,
    SaldoComprometidoXCuenta: `${baseUrl}${mantenimientoController}/SaldoComprometidoXCuenta`, 
    SubTiposCuentas_Listar: `${baseUrl}${mantenimientoController}/SubTiposCuentas_Listar`,
    SubTiposCuentas_Consulta: `${baseUrl}${mantenimientoController}/SubTiposCuentas_Consulta`,
    SubTiposCuentas_Guardar: `${baseUrl}${mantenimientoController}/SubTiposCuentas_Guardar`,
    SubTiposCuentas_Modificar: `${baseUrl}${mantenimientoController}/SubTiposCuentas_Modificar`,
    SubTiposCuentas_Eliminar: `${baseUrl}${mantenimientoController}/SubTiposCuentas_Eliminar`,
    InsertarEtiquetasReporte: `${baseUrl}${mantenimientoController}/InsertarEtiquetasReporte`,
    SubTiposCuentas_ListTipoCuentas: `${baseUrl}${mantenimientoController}/SubTiposCuentas_ListTipoCuentas`,
}

export const ReporteRutas = {
    //Get_Description_Report : `${baseUrl}${Reporte}/Get_Description_Report`,
    SetParametrosReporte: `${baseUrl}${Reporte}/SetParametrosReporte`,
}

export const Seguridad = {

    Empresa_Lista: `${baseUrl}${seguridad}/Empresa_Lista`,
    Empresa_Consulta: `${baseUrl}${seguridad}/Empresa_Consulta`,
    Empresa_Eliminar: `${baseUrl}${seguridad}/Empresa_Eliminar`,
    Empresa_Foto: `${baseUrl}${seguridad}/Empresa_Foto`,
    Empresa_Guardar: `${baseUrl}${seguridad}/Empresa_Guardar`,
    Empresa_Modificar: `${baseUrl}${seguridad}/Empresa_Modificar`,
    Empresa_ModificarImagen: `${baseUrl}${seguridad}/Empresa_ModificarImagen`,
    Organigrama_Lista: `${baseUrl}${seguridad}/Organigrama_Lista`,
    Seg_Usuario_Encriptar_Llave: `${baseUrl}${seguridad}/Seg_Usuario_Encriptar_Llave`,
    Seg_Usuario_Login_App: `${baseUrl}${seguridad}/Seg_Usuario_Login_App`,
    Seg_Usuario_Listar: `${baseUrl}${seguridad}/Seg_Usuario_Listar`,
}

export const ServiciosRutas = {
    Catalogo_Lista: `${baseUrl}${servicioController}/Catalogo_Lista`,
    Catalogo_Lista_Tipos: `${baseUrl}${servicioController}/Catalogo_Lista_Tipos`,
    Catalogo_ListarTablaSaldos: `${baseUrl}${servicioController}/Catalogo_ListarTablaSaldos`,
    Catalogo_Consulta: `${baseUrl}${servicioController}/Catalogo_Consulta`,
    Consulta_Comprometidos: `${baseUrl}${servicioController}/Consulta_Comprometidos`,
    Catalogo_ConsultaCuenta: `${baseUrl}${servicioController}/Catalogo_ConsultaCuenta`,    
    Catalogo_Eliminar: `${baseUrl}${servicioController}/Catalogo_Eliminar`,
    Catalogo_Guardar: `${baseUrl}${servicioController}/Catalogo_Guardar`,
    Catalogo_Guardar_Masivo: `${baseUrl}${servicioController}/Catalogo_Guardar_Masivo`,
    Catalogo_HayCatalogoCuentas:`${baseUrl}${servicioController}/Catalogo_HayCatalogoCuentas`,
    Catalogo_ImportarCatalogo:`${baseUrl}${servicioController}/Catalogo_ImportarCatalogo`,
    CentroCosto_Lista: `${baseUrl}${servicioController}/CentroCosto_Lista`,
    Catalogo_Modificar: `${baseUrl}${servicioController}/Catalogo_Modificar`,
    Catalogo_ModificarCatTipo: `${baseUrl}${servicioController}/Catalogo_ModificarCatTipo`,
    CentroCosto_Consulta: `${baseUrl}${servicioController}/CentroCosto_Consulta`,
    CentroCosto_ConsultaCCosto: `${baseUrl}${servicioController}/CentroCosto_ConsultaCCosto`,
    CentroCosto_Lista_CXCC: `${baseUrl}${servicioController}/CentroCosto_Lista_CXCC`,
    CentroCosto_Lista_CXCCEmpresa: `${baseUrl}${servicioController}/CentroCosto_Lista_CXCCEmpresa`,
    CentroCosto_Lista_CCC: `${baseUrl}${servicioController}/CentroCosto_Lista_CCC`,
    CentroCosto_Consulta_CXCC: `${baseUrl}${servicioController}/CentroCosto_Consulta_CXCC`,
    CentroCostos_CentroDefault: `${baseUrl}${servicioController}/CentroCostos_CentroDefault`,
    CatalogoCentroCosto_Guardar: `${baseUrl}${servicioController}/CatalogoCentroCosto_Guardar`,
    CatalogoCentroCosto_GuardarCC: `${baseUrl}${servicioController}/CatalogoCentroCosto_GuardarCC`,
    CatalogoCentroCosto_Modificar: `${baseUrl}${servicioController}/CatalogoCentroCosto_Modificar`,
    CatalogoCentroCosto_ModificarCC: `${baseUrl}${servicioController}/CatalogoCentroCosto_ModificarCC`,
    CatalogoCentroCosto_Eliminar: `${baseUrl}${servicioController}/CatalogoCentroCosto_Eliminar`,
    CatalogoCentroCosto_EliminarCC: `${baseUrl}${servicioController}/CatalogoCentroCosto_EliminarCC`,
    MesesCerrados_Consulta: `${baseUrl}${servicioController}/MesesCerrados_Consulta`,
    DatosGral_Consulta:`${baseUrl}${servicioController}/DatosGral_Consulta`,
    ParametroGenerales_Consulta:`${baseUrl}${servicioController}/ParametroGenerales_Consulta`,
    ParametroGenerales_Listar: `${baseUrl}${servicioController}//ParametroGenerales_Listar`,
    ParametroGenerales_Guardar: `${baseUrl}${servicioController}//ParametroGenerales_Guardar`,
    ParametroGenerales_Modificar:`${baseUrl}${servicioController}//ParametroGenerales_Modificar`,
    ParametroGenerales_Eliminar: `${baseUrl}${servicioController}//ParametroGenerales_Eliminar`,
    ParametrosGenerales_GuardarActualizar: `${baseUrl}${servicioController}//ParametrosGenerales_GuardarActualizar`,
}

//Url Routes for Components ALPHABET ORDER
export const SiteRutas = {
    Base: '/',
    Home: '/Home',
    Asientos: '/asientos',
    AsociarCentroCosto:`/asociarCentroCosto`,
    CambiarContrasena: `/cambiarContrasena`,
    CargaAsientoExcel: `/cargaAsientoExcel`,
    CentrosCosto: `/centrosCosto`,
    CentrosUtilidad:`/centrosUtilidad`,
    CatalogoCentroCosto:`/catalogoCentroCosto`,
    CatalogoCuentas:`/catalogoCuentas`,    
    CierreAnual: `/cierreAnual`,   
    CierreMensual: `/cierreMensual`,   
    ConciliacionAuxiliares: `/conciliacionAuxiliares`,
    Corporacion: `/corporacion`,   
    DesbloquearAsiento: `/desbloquearAsiento`,
    DetalleAsiento:`/DetalleAsiento`,
    Empresa: `/empresa`,
    EstadoAsiento: `/estadoAsiento`,
    EtiquetasReportes: `/etiquetasReportes`,
    ImportarCatalogo:`/importarCatalogo`,
    ImportarTiposAsiento:`/importarTiposAsiento`,
    ImportarExcel: `/importarExcel`,
    InsertarMasivo:`/insertarMasivo`,
    Login: `${baseUrlRel}Login`,
    MantAsientos: '/MantAsientos',
    MantCatalogoCuentas: `/mantCatalogoCuentas`,
    MantCatalogoCentroCosto: `/MantCatalogoCentroCosto`,
    MantCentrosCostos: `/MantCentrosCostos`,
    MantCentroUtilidad: `/mantCentroUtilidad`,
    MantCorporaciones: `/mantCorporaciones`,
    MantEmpresasInt:`/mantEmpresasInt`,
    MantPlantillas: '/MantPlantillas',
    MantPresupuesto: '/mantPresupuesto',
    MantSubTiposCuentas:`/mantSubTiposCuentas`,
    MantTiposAsientos: `/mantTiposAsientos`,
    Parametros:'/parametros',
    Plantillas: '/plantillas',
    MantPresupuesto: '/presupuesto',
    Reporte: `/reporte`,
    TipoCuentas:`/tiposCuentas`,
    TiposAsientos: `/tiposAsientos`,
};

//IMAGENES
export const ImagenesRutas = {
    Fondo_Login: `${baseUrl}Content/Images/login-bg-min.jpg`,
    FotosEmpleadosUbicacion: `${baseUrl}Content/Images/`,
    DescExcel_CargaAsiento: `${baseUrl}Content/Images/descExcel_CargaAsiento.png`,  
    DescExcel_Presupuesto: `${baseUrl}Content/Images/descExcel_Presupuesto.png`, 
    Logo: `${baseUrl}Content/Images/logo.png`,
    Logo_Fas: `${baseUrl}Content/Images/logo-fas.png`,
    Logo_LD_Blanco: `${baseUrl}Content/Images/ld-blanco.png`,
    Logo_LD: `${baseUrl}Content/Images/logo-ld.png`,
    Main_LD: `${baseUrl}Content/Images/main-bg.jpg`,
    Parametros: `${baseUrl}Content/Images/parametros.png`,
    Ping: `${baseUrl}Content/Images/map_marker.png`,
    PicDefault: `${baseUrl}Content/Images/default.png`,
    UserIcon: `${baseUrl}Content/Images/user-icon.png`,
    userMenu: `${baseUrl}Content/Images/user.png`,
};
//arbol
export const UtilitariosRutas = {
    perfectScrollbar: `${baseUrl}contabilidad/src/lib/perfect-scrollbar/perfect-scrollbar.js`,
    MultiNestedList: `${baseUrl}contabilidad/src/lib/utilitarios/MultiNestedList.js`,
    Webslidemenu: `${baseUrl}contabilidad/src/lib/utilitarios/webslidemenu.js`
}

//Request Header
export const GetHeaderRequest = pToken => {

    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${pToken}`
    }
};


export const GetHeaderRequestFormData = pToken => {
    return {
        'Authorization': `Bearer ${pToken}`
    }
};


export const GetResponseBody = pResponse => {
    const contentType = pResponse.headers["content-type"];
    if (contentType && contentType.indexOf("application/json") !== -1) {
        return pResponse.data;
    } else {
        switch (pResponse.status) {
            case 401:
                return { Exitoso: false, Mensaje: 'No tiene permisos para acceder a este método.', CodigoError: 2 };
            case 500:
                return { Exitoso: false, Mensaje: 'Ocurrió un error en el servidor.', CodigoError: 999 };
            default:
                return { Exitoso: false, Mensaje: 'Ocurrió un error realizando la acción.', CodigoError: 999 };
        }
    }
};

export const GetResponseBodyFecth = pResponse => {
    const contentType = pResponse.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
        return pResponse.json();
    } else {
        switch (pResponse.status) {
            case 401:
                return { Exitoso: false, Mensaje: 'No tiene permisos para acceder a este método.', CodigoError: 2 };
            case 500:
                return { Exitoso: false, Mensaje: 'Ocurrió un error en el servidor.', CodigoError: 999 };
            default:
                return { Exitoso: false, Mensaje: 'Ocurrió un error realizando la acción.', CodigoError: 999 };
        }
    }
};

export const GetResponseBodyFetch = pResponse => {

    const contentType = pResponse.headers.get("content-type");

    return pResponse.json();

};




